import React from "react";
import { Helmet } from "react-helmet";

export const USwitch: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => (
  <>
    <Helmet>
      <link rel="stylesheet" type="text/css" href="/partners/uSwitch.css" />
    </Helmet>
    <div className="partner-uSwitch">{children}</div>
  </>
);
